import { ResidentVehicle } from '@/models'

export const formatResidentParkingVehicleDetails = (
  vehicle: ResidentVehicle,
  options: { showLicensePlate?: boolean } = {
    showLicensePlate: false,
  },
) => {
  const plate = vehicle.licensePlate?.trim()
  const make = vehicle.make?.trim()
  const model = vehicle.model?.trim()
  const color = vehicle.color?.trim()

  const parts = [
    ...(plate && options.showLicensePlate ? [plate] : []),
    ...(make ? [make] : []),
    ...(model ? [model] : []),
    ...(color ? [color] : []),
    ...(vehicle.year != null ? [String(vehicle.year)] : []),
  ]

  return parts.length > 0 ? parts.join(', ') : '-'
}
